import { CarouselItems } from '../models/carousel-items.enum';

export interface ScrollSizeInfo {
  normal: number;
  mobile: number;
}

export const getCardWidthInfo = (
  carouselItem: CarouselItems
): ScrollSizeInfo => {
  switch (carouselItem) {
    case CarouselItems.VOTW:
      return { normal: 336, mobile: 155 };
    case CarouselItems.Video:
    case CarouselItems.Gps:
    case CarouselItems.Workout:
    case CarouselItems.Coaching:
      return { normal: 422, mobile: 218 };
    case CarouselItems.VideoDetail:
    case CarouselItems.GpsDetail:
    case CarouselItems.WorkoutDetail:
    case CarouselItems.CoachingDetail:
      return { normal: 422, mobile: 155 };
    case CarouselItems.Playlist:
      return { normal: 269, mobile: 155 };
    case CarouselItems.VideoPoster:
      return { normal: 269, mobile: 143 };
    case CarouselItems.Landscape:
      return { normal: 422, mobile: 155 };
    case CarouselItems.Region:
      return { normal: 269, mobile: 143 };
    default:
      return { normal: 30, mobile: 30 };
  }
};
